<template>
  <div class="min-h-screen bg-gray-100">
    <div v-if="!isMobile()" class="sticky top-0 z-50 bg-white shadow">
      <HeaderComponent 
        :cartItemCount="cart.length"
        :isLoggedIn="isLoggedIn"
        @search="applySearch"
        @sort="applySort"
      />
    </div>
    <div v-if="isMobile()" class="top-0 z-50 bg-white shadow">
      <HeaderComponent 
        :cartItemCount="cart.length"
        :isLoggedIn="isLoggedIn"
        @search="applySearch"
        @sort="applySort"
      />
    </div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div class="flex flex-col md:flex-row gap-2">
        <div v-if="isMobile()">
          <MobileFilter
            :brands="brands"
            :types="types"
            :categories="categories"
            @filter="applyFilter"
          />
        </div>
        <!-- Sidebar for desktop -->
        <SideBar
      v-if="!isMobile()"
      :brands="brands"
      :types="types"
      :categories="categories"
      @filter="applyFilter"
      class="w-full md:w-64 flex-shrink-0 md:sticky md:top-20 md:h-screen md:overflow-y-auto"
    />

        <!-- Product List -->
        <div class="flex-grow">
          <ProductList 
            :products="adjustedFilteredProducts"
            :isMobile="isMobile()"
            @show-detail="showProductDetail"
          />
        </div>
      </div>
    </div>

    <ProductDetailModal
      v-if="selectedProduct"
      :show="!!selectedProduct"
      :product="selectedProduct"
      @close="selectedProduct = null"
    />
  </div>
</template>

<script>
import SideBar from '../components/SideBar.vue'
import ProductList from '../components/ProductList.vue'
import ProductDetailModal from '../components/ProductDetailModal.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'
import MobileFilter from '@/components/MobileFilter.vue'
import { acService } from '../services/api'

export default {
  name: 'HomeView',
  components: {
    SideBar,
    ProductList,
    ProductDetailModal,
    HeaderComponent,
    MobileFilter,
  },
  data() {
    return {
      products: [],
      brands: [],
      types: [],
      categories: [],
      cart: [],
      showCart: false,
      selectedProduct: null,
      filters: {
        brands: [],
        types: [],
        categories: [],
        pk: [0, 10],
        search: ''
      },
      sortBy: 'name',
      isLoggedIn: false,
      showLoginPromptModal: false,
      loginPromptAction: '',
      isLoading: false,
      error: null,
      showMobileFilter: false,
      showSuccessModal: false,
    }
  },
  computed: {
    filteredProducts() {
      return this.products.filter(product => {
        if (typeof product !== 'object' || product === null) {
          console.warn('Invalid product:', product);
          return false;
        }

        const brandMatch = this.filters.brands.length === 0 || 
          (product.brand && this.filters.brands.includes(product.brand.brand_name));
        
        const typeMatch = this.filters.types.length === 0 || 
          (product.type && this.filters.types.includes(product.type.type_name));
        
        const categoryMatch = this.filters.categories.length === 0 || 
          (product.category && this.filters.categories.includes(product.category.category_name));
        
        const pkMatch = !product.pk_power || 
          (parseFloat(product.pk_power) >= this.filters.pk[0] && 
           parseFloat(product.pk_power) <= this.filters.pk[1]);
        
           const searchMatch = !this.filters.search || (
          (product.title && product.title.toLowerCase().includes(this.filters.search.toLowerCase())) ||
          (this.filters.includeSellerName && product.user && 
           product.user.name && product.user.name.toLowerCase().includes(this.filters.search.toLowerCase())) ||
          (this.filters.includeSellerAddress && product.user && 
           product.user.address && product.user.address.toLowerCase().includes(this.filters.search.toLowerCase()))
        );
        return brandMatch && typeMatch && categoryMatch && pkMatch && searchMatch;
      }).sort((a, b) => {
        if (this.sortBy === 'name') {
          return (a.title || '').localeCompare(b.title || '');
        } else if (this.sortBy === 'price') {
          return (parseFloat(a.price) || 0) - (parseFloat(b.price) || 0);
        }
        return 0;
      });
    },
    adjustedFilteredProducts() {
    return this.filteredProducts.map(product => ({
      ...product,
      price: product.price ? (parseFloat(product.price) * 1.1).toFixed(2) : product.price
    }));
  }
  },
  created() {
    this.fetchProducts()
  },
  methods: {
    isMobile() {
      return screen.width <= 760;
    },
    async fetchProducts() {
      try {
        const response = await acService.getList();
        this.products = response.data.data || [];
        this.extractBrandsTypesAndCategories();
      } catch (error) {
        console.error('Failed to fetch products:', error);
      }
    },
    extractBrandsTypesAndCategories() {
      const brandSet = new Set();
      const typeSet = new Set();
      const categorySet = new Set();
      this.products.forEach(product => {
        if (product.brand && product.brand.brand_name) {
          brandSet.add(product.brand.brand_name);
        }
        if (product.type && product.type.type_name) {
          typeSet.add(product.type.type_name);
        }
        if (product.category && product.category.category_name) {
          categorySet.add(product.category.category_name);
        }
      });
      this.brands = Array.from(brandSet);
      this.types = Array.from(typeSet);
      this.categories = Array.from(categorySet);
    },
    showProductDetail(product) {
  this.$router.replace({ 
    query: { productId: product.id }
  })
  this.selectedProduct = product
},
    applyFilter(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
      if (this.isMobile()) {
        this.toggleMobileFilter();
      }
    },
    closeSuccessModal() {
      this.showSuccessModal = false
    },
    applySearch({ query, includeSellerName, includeSellerAddress }) {
      this.filters.search = query;
      this.filters.includeSellerName = includeSellerName;
      this.filters.includeSellerAddress = includeSellerAddress;
    },
    applySort(sortBy) {
      this.sortBy = sortBy
    },
    toggleMobileFilter() {
      this.showMobileFilter = !this.showMobileFilter
    },
  },
  watch: {
  '$route.query.productId'(value) {
    if (!value) {
      this.selectedProduct = null
    }
  }
},
}
</script>